import { Stack } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { CsvColumnDef } from "src/utils/csv";
import { UserRow } from "components/users/userAdminFilters";
import { UserAdminState } from "components/users/userAdminState";
import { UserFilterBar } from "components/users/userFilterBar";
import { UserBulkActionBar } from "components/users/userBulkActionBar";
import { UsersDataGrid } from "components/users/usersDataGrid";

const tabContentSx = { height: "100%", pt: 2 } as const;

export const UserTab = ({
  state,
  variant,
  csvColumns,
}: {
  state: UserAdminState;
  variant: "users" | "serviceAccounts";
  csvColumns: CsvColumnDef<UserRow>[];
}) => {
  const { t } = useTenantTranslation();
  const isUsers = variant === "users";

  const rows = isUsers ? state.filteredUsers : state.filteredServiceAccounts;
  const selection = isUsers
    ? state.usersSelection
    : state.serviceAccountsSelection;
  const setSelection = isUsers
    ? state.setUsersSelection
    : state.setServiceAccountsSelection;

  return (
    <Stack spacing={2} sx={tabContentSx}>
      <UserFilterBar
        search={state.searchText}
        onSearchChange={state.setSearchText}
        searchPlaceholder={t("searchNameOrEmail")}
        quickFilters={{
          active: state.quickFilters,
          onToggle: state.toggleQuickFilter,
        }}
        exportRows={rows}
        exportColumns={csvColumns}
      />
      <UserBulkActionBar
        selectedCount={selection.length}
        busy={state.isBulkBusy}
        onClear={() => {
          setSelection([]);
        }}
        onEnable={() => void state.bulkSetEnabled(selection, true)}
        onDisable={() => void state.bulkSetEnabled(selection, false)}
        onGrantPermission={(permission) =>
          void state.bulkSetPermission(selection, permission, true)
        }
        onRevokePermission={(permission) =>
          void state.bulkSetPermission(selection, permission, false)
        }
      />
      <UsersDataGrid
        rows={rows}
        loading={state.isUsersFetching}
        accountType={isUsers ? "user" : "service_account"}
        selection={selection}
        onSelectionChange={setSelection}
        onRowClick={state.openDrawer}
        onCreateInviteLink={state.createInviteLink}
        onSendInviteEmail={(email) => void state.sendInvite(email)}
        emptyText={isUsers ? t("noUsersFound") : t("noServiceAccounts")}
      />
    </Stack>
  );
};
